import React, {ChangeEvent} from 'react';
import b_ from 'b_';

import {SelectWithBodyPopup} from 'client/common/components/lego';
import {TargetingInterests} from 'client/common/utils/audience';

import {convertToLegoOptions} from './helpers';

import {InterestsProps} from './types';

const b = b_.with('audience-settings');

export default function Interests(props: InterestsProps) {
    const {disabled, onChange, interests, selected} = props;

    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const {value} = event.target;

        onChange(value);
    };

    const selectOptions = TargetingInterests.getInterestOptions(interests);

    const selectedLabel = TargetingInterests.getInterestLabel(interests, selected);

    return (
        <span className={b('parameter-select')}>
            <SelectWithBodyPopup
                disabled={disabled}
                placeholder={selectedLabel}
                showAlwaysPlaceholder
                onChange={handleChange}
                options={convertToLegoOptions(selectOptions)}
                value={selected}
                view='dl-clear'
                size='m'
                width='max'
            />
        </span>
    );
}
